"use client";

import './modal-footer.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import '../../buttons/button/index.js';
import { ButtonGroup } from '../../buttons/button-group/index.js';
import '../../buttons/button-icon/index.js';
import '../../buttons/text-link/index.js';
import '../../_virtual/_tslib.js';
import 'react';
import '../../icons/component-icons/left-caret-bold/index.js';
import '../../icons/component-icons/right-caret-bold/index.js';
import styles from './modal-footer.module.scss.js';

/**
 * @component Modal
 * @package Modals
 */
const ModalFooter = ({ buttonGroup, viewport, toggleModal, noCloseButton, // To fix a screenreader issue on mobile
footerIndex, // To fix a screenreader issue on mobile
isMobileDevice, // To fix a screenreader issue on mobile
children, colorMode = 'light', }) => {
    const footerStyles = [styles.footer];
    const _buttonOnClick = (e, close, onClick) => {
        if (close && toggleModal) {
            toggleModal();
        }
        if (onClick) {
            onClick(e);
        }
    };
    return (jsxs("div", { className: footerStyles.join(' '), style: {
            order: isMobileDevice && !noCloseButton ? footerIndex : undefined,
        }, children: [children, buttonGroup && Object.keys(buttonGroup).length > 0 && (jsx(ButtonGroup, { viewport: viewport, alignment: buttonGroup.alignment || 'center', rowQuantity: buttonGroup.rowQuantity || {
                    mobileSmall: 1,
                    mobile: 1,
                    mobileLarge: 1,
                    tabletLarge: 2,
                    tabletSmall: 2,
                    desktop: 2,
                }, buttonWidth: buttonGroup.buttonWidth || '100%', items: buttonGroup.items.map((item) => (Object.assign(Object.assign({}, item), { onClick: (e) => _buttonOnClick(e, item.close, item.onClick) }))), surface: colorMode === 'light' ? 'lightPrimary' : 'darkPrimary', width: buttonGroup.width }))] }));
};

export { ModalFooter as default };
